import ReadOnly from './permission';

const install = function(Vue) {
  Vue.directive('ReadOnly', ReadOnly);
};

if (window.Vue) {
  Vue.use(install); // eslint-disable-line
}

ReadOnly.install = install;
export default ReadOnly;